module.exports = __webpack_public_path__ + "static/media/wish_VIII_cs.3173a6c0.png";